import Swiper from 'swiper';
import viewport from "./viewport";

export default function () {

    if(viewport().width > 765) {
        let galleryThumbs = new Swiper('.thumbs-gallery', {
            spaceBetween: 20,
            speed: 600,
            slidesPerView: 'auto',
            direction: 'horizontal',
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
            slideToClickedSlide: true,
            navigation: {
                nextEl: document.getElementsByClassName('thumbs-gallery__next-arrow')[0]
            },
            breakpoints: {
                765: {
                    slidesPerView: 'auto',
                    spaceBetween: 20,
                    direction: 'vertical',
                    pagination: false
                }
            }
        });


        let galleryTop = new Swiper('.detail-gallery', {
            speed: 600,
            loop: true,
            effect: 'fade',
            fadeEffect: {crossFade: true},
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
            pagination: {
                el: '.product-gallery .swiper-pagination',
                clickable: true
            },
            breakpoints: {
                765: {
                    pagination: false
                }
            },
            thumbs: {
                swiper: galleryThumbs
            }
        });
    }
    else{

        let galleryTop = new Swiper('.detail-gallery', {
            speed: 600,
            loop: true,
            pagination: {
                el: '.product-gallery .swiper-pagination',
                clickable: true
            }
        });
    }


    let inlineVideoMobile = document.getElementsByClassName('detail-gallery__item--video-mobile');

    Array.from(inlineVideoMobile).forEach(button => button.addEventListener('click', function(e){
        if(viewport().width < 980) {
            this.classList.add('is-active');

            let frame = this.getElementsByTagName('iframe')[0];
            frame.src = frame.src + '?autoplay=1';
        }
    }));


}
